module.exports = __webpack_public_path__ + "img/wxt4.0b683db1.jpg";